export default "__VITE_ASSET__CfeMWGuU__"